import FuelSurchargesComponent from './fuel_surcharges.component';
import FuelSurchargesCreate from './create';
import FuelSurchagesAll from './all';
import FuelSurchargesEdit from './edit';
import PricePoint from './price_point';
import CustomerNotAssociated from './customer_not_associated';
import LocationNotAssociated from './location_not_associated';

let FuelSurchargesComponentModule = angular.module('fuelSurcharges', [
    FuelSurchagesAll,
    FuelSurchargesCreate,
    FuelSurchargesEdit,
    PricePoint,
    CustomerNotAssociated,
    LocationNotAssociated
])

    .component('fuelSurcharges', FuelSurchargesComponent)
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/fuel-surcharges');

        $stateProvider
            // .state('fuelSurcharges', {
            //     url: '/fuel-surcharges',
            //     component: 'fuelSurcharges',
            //     data: {
            //         requireLogin: true,
            //         requireACL: 'fuel_surcharges.view'
            //     },
            //     parent: 'app'
            // })

            .state('fuel_surcharges.all', {
                url: '/all/:page',
                component: 'fuelsurchargesall',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_fuel_surcharges.view'
                },
            })
            .state('fuel_surcharges.create', {
                url: '/create',
                component: 'fuelsurchargescreate',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_fuel_surcharges.create'
                }
            })
            .state('fuel_surcharges.edit', {
                url: '/edit/:id',
                component: 'fuelsurchargesedit',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_fuel_surcharges.edit'
                }
            })
            .state('fuel_surcharges.pricePoint', {
                url: '/price-point',
                component: 'pricepoint',
                data: {
                    requireLogin: true,
                    requireACL: 'tnt_billing_fuel_surcharges.view'
                }
            })
            .state('fuel_surcharges.customernotassociated', {
                url: '/customer-not-associate',
                component: 'customernotassociated',

            })
            .state('fuel_surcharges.locationnotassociated', {
                url: '/location-not-associate',
                component: 'locationnotassociated',

            })
    })
    .name;

export default FuelSurchargesComponentModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/index.js